// Anonymous per-device id used to count one Chart Three score per player per day.
export const deviceId = () => {
  let id = localStorage.getItem("cv_device");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("cv_device", id);
  }
  return id;
};
